import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const contract = {
  state: {
    locale: {
      formLocale: "da-DK",
      contractLocale: "da-DK"
    },
    isDistributorType: true,
    contractDetails: {
      contractType: "Distributør",
      isDistributor: true,
      agreementDate: ""
    },
    durationAndResignation: {
      selectedDuration: "Tidsubegrænset",
      earliestResignation: "",
      fromDate: "",
      toDate: "",
      period: "",
      notice: {
        firstPeriod: "",
        otherPeriod: ""
      }
    },
    goodwillPercent: "",
    otherRegulations: [],
    parties: {
      distributor: {
        name: "",
        cvr: "",
        address: "",
        zipCity: "",
        country: ""
      },
      supplier: {
        name: "",
        cvr: "",
        address: "",
        zipCity: "",
        country: ""
      }
    },
    productsAndArea: {
      products: [],
      areas: "",
      hasExclusiveRight: false
    },
    signature: {
      date: ""
    },
    supplierRightsAndObligations: {
      compensationPercentage: ""
    },
    distributorRightsAndObligations: {
      shouldParticipate: false,
      numberOfFairs: "",
      marketingPercent: ""
    },
    venueGoverningLaw: {
      eeaOrEu: false
    }
  },
  mutations: {
    updateFormLocale(state, locale) {
      state.locale.formLocale = locale;
    },
    updateContractLocale(state, locale) {
      state.locale.contractLocale = locale;
    },
    updateIsDistributorType(state, isDistributorType) {
      state.isDistributorType = isDistributorType;
    },
    updateContractDetails(state, contractDetails) {
      state.contractDetails = contractDetails;
    },
    updateDistributor(state, distributor) {
      state.parties.distributor = distributor;
    },
    updateSupplier(state, supplier) {
      state.parties.supplier = supplier;
    },
    updateAgreementDate(state, agreementDate) {
      state.parties.agreementDate = agreementDate;
    },
    updateProductsAndArea(state, productsAndArea) {
      state.productsAndArea = productsAndArea;
    },
    updateSupplierRightsAndObligations(state, supplierRightsAndObligations) {
      state.supplierRightsAndObligations = supplierRightsAndObligations;
    },
    updateDistributorRightsAndObligations(state, distributorRightsAndObligations) {
      state.distributorRightsAndObligations = distributorRightsAndObligations;
    },
    updateDurationAndResignation(state, durationAndResignation) {
      state.durationAndResignation = durationAndResignation;
    },
    updateGoodwillPercent(state, goodwillPercent) {
      state.goodwillPercent = goodwillPercent;
    },
    updateOtherRegulations(state, otherRegulations) {
      state.otherRegulations = otherRegulations;
    },
    updateVenueGoverningLaw(state, venueGoverningLaw) {
      state.venueGoverningLaw = venueGoverningLaw;
    },
    updateSignatureDate(state, signatureDate) {
      state.signature.date = signatureDate;
    }
  },
  getters: {
    isDistributorType: state => state.contractDetails.isDistributor,
    isExclusive: state => state.productsAndArea.hasExclusiveRight
  }
};

export const store = new Vuex.Store({
  modules: {
    contract
  }
});



// WEBPACK FOOTER //
// ./src/apps/eneforhandler/store.js